import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAPoliticalScienceCoursePage: React.FC = () => {
  const courseData = {
    title: "B.A. Political Science",
    shortName: "B.A. Political Science",
    duration: "3 years",
    description: "Bachelor's degree program focused on political theory, government systems, and public administration",
    overview: "Bachelor of Arts in Political Science (B.A. Political Science) is a 3-year undergraduate program that provides comprehensive study of political systems, governance, international relations, and public policy. This course covers political theory, comparative politics, Indian government, international relations, and public administration, preparing students for careers in government, politics, journalism, and civil services.",
    eligibility: [
      "10+2 in any stream",
      "Minimum 50% marks in 12th standard",
      "Interest in politics and governance",
      "Good analytical and communication skills"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Introduction to Political Theory",
          "Indian Government and Constitution",
          "Comparative Government",
          "Political Sociology",
          "General English",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "International Relations",
          "Public Administration",
          "Political Economy",
          "Modern Political Thought",
          "Local Government",
          "Research Methodology"
        ]
      },
      {
        year: 3,
        subjects: [
          "Contemporary Political Issues",
          "Foreign Policy Analysis",
          "Human Rights",
          "Electoral Politics",
          "Project Work",
          "Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Civil Services Officer",
        "Political Analyst",
        "Journalist",
        "Policy Researcher",
        "Diplomat",
        "Political Consultant",
        "NGO Worker",
        "Government Relations Officer",
        "Academic Researcher",
        "Campaign Manager"
      ],
      industries: [
        "Government Services",
        "Political Organizations",
        "Media and Journalism",
        "Non-Profit Sector",
        "International Organizations",
        "Think Tanks",
        "Consulting Firms",
        "Educational Institutions",
        "Law Firms",
        "Corporate Affairs"
      ],
      averageSalary: "₹3-7 LPA (Fresher), ₹12-50 LPA (Senior Govt positions)",
      topRecruiters: [
        "UPSC, State PSCs",
        "Ministry of External Affairs",
        "Media Houses",
        "Political Parties",
        "NGOs and Think Tanks",
        "International Organizations"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "DU, JNU conduct specific entrance exams",
      "Cut-off based selection",
      "Online application process"
    ],

    topColleges: [
      {
        name: "Jawaharlal Nehru University",
        location: "Delhi",
        fees: "₹2,000",
        ranking: "NIRF Ranking: 2"
      },
      {
        name: "Hindu College",
        location: "Delhi",
        fees: "₹25,000",
        ranking: "NIRF Ranking: 5"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000",
        ranking: "Premier Government College"
      },
      {
        name: "St. Xavier's College",
        location: "Mumbai",
        fees: "₹35,000",
        ranking: "Autonomous College"
      }
    ],

    skills: [
      "Political Analysis",
      "Policy Research",
      "Public Speaking",
      "Critical Thinking",
      "Research Skills",
      "Writing and Communication",
      "International Awareness",
      "Leadership Skills",
      "Negotiation Skills",
      "Current Affairs Knowledge"
    ],

    futureScope: "Excellent opportunities in civil services, international relations, policy making, political consulting, and growing importance of governance in digital age.",

    faqs: [
      {
        question: "What career opportunities exist after B.A. Political Science?",
        answer: "Career options include civil services, journalism, politics, diplomacy, NGO work, policy research, and further studies like M.A. Political Science or law."
      },
      {
        question: "Is this course good for UPSC preparation?",
        answer: "Yes, Political Science provides excellent foundation for civil services with strong background in governance, polity, and international relations."
      },
      {
        question: "Can I work in media with Political Science degree?",
        answer: "Yes, political science graduates work as political correspondents, policy analysts, and current affairs experts in media organizations."
      },
      {
        question: "Are there opportunities in international organizations?",
        answer: "Yes, with further studies and experience, you can work with UN, World Bank, diplomatic missions, and international NGOs."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAPoliticalScienceCoursePage;
